import { axiosClient } from "@/shared/api/axios-client";
import type { EquivalenciaUnidad, Paginado } from "@/lib/types";

export interface CrearEquivalenciaInput {
  claveUnidadSat: string;
  unidadSap: string;
  descripcion: string | null;
}

export interface EditarEquivalenciaInput {
  unidadSap: string;
  descripcion: string | null;
  activo: boolean;
}

export interface ListarEquivalenciasParams {
  busqueda?: string;
  page?: number;
  pageSize?: number;
}

/**
 * Listado PAGINADO server-side (endpoint /paginado · AdminPaginadoEndpoints;
 * el GET plano original de AdminEndpoints queda intacto).
 */
export async function listarEquivalenciasPaginado(
  params: ListarEquivalenciasParams = {}
): Promise<Paginado<EquivalenciaUnidad>> {
  const { data } = await axiosClient.get<Paginado<EquivalenciaUnidad>>(
    "/api/admin/equivalencias-unidad/paginado",
    { params }
  );
  return data;
}

export async function crearEquivalencia(input: CrearEquivalenciaInput): Promise<EquivalenciaUnidad> {
  const { data } = await axiosClient.post<EquivalenciaUnidad>("/api/admin/equivalencias-unidad", input);
  return data;
}

export async function editarEquivalencia(
  id: string,
  input: EditarEquivalenciaInput
): Promise<EquivalenciaUnidad> {
  const { data } = await axiosClient.put<EquivalenciaUnidad>(
    `/api/admin/equivalencias-unidad/${id}`,
    input
  );
  return data;
}

export async function eliminarEquivalencia(id: string): Promise<void> {
  await axiosClient.delete(`/api/admin/equivalencias-unidad/${id}`);
}
